import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { getMonthlySales } from '../../../../appRedux/actions/Reports';
import { getSubsidiaries } from '../../../../appRedux/actions';
import { CustomSelect } from '../../../uiComponents';

export const MonthlySalesFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values?.year) {
      values.year = moment(values?.year).format('YYYY');
    }
    dispatch(getMonthlySales(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="year">
            <DatePicker picker="year" format={'YYYY'} />
          </Form.Item>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ width: 200 }}
              options={subsidiaries?.map(({ id, name }) => ({
                label: name,
                value: id,
              }))}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
